// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import { USER_ROLES } from "../../staticData/userRoles";
import { getNewEventUrl } from "../../utils/constants/urls";
import { ALERT_DIALOG } from "../constants/auth";
import {
  ARCHIVE_EVENT_FAILURE,
  ARCHIVE_EVENT_REQUEST,
  ARCHIVE_EVENT_SUCCESS,
  ASSIGN_CLIENT_FAILURE,
  ASSIGN_CLIENT_REQUEST,
  ASSIGN_CLIENT_SUCCESS,
  CLEAR_EVENT_REQUEST_LIST,
  DELETE_EVENT_FAILURE,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_SUCCESS,
  FETCH_NEW_EVENT_FAILURE,
  FETCH_NEW_EVENT_REQUEST,
  FETCH_NEW_EVENT_SUCCESS,
  SEARCH_NEW_EVENT_FAILURE,
  SEARCH_NEW_EVENT_REQUEST,
  SEARCH_NEW_EVENT_SUCCESS,
  UPDATE_CONTACT_INFORMATION_FAILURE,
  UPDATE_CONTACT_INFORMATION_REQUEST,
  UPDATE_CONTACT_INFORMATION_SUCCESS,
  UPDATE_EVENT_INFORMATION_FAILURE,
  UPDATE_EVENT_INFORMATION_REQUEST,
  UPDATE_EVENT_INFORMATION_SUCCESS,
} from "../constants/eventRequest";
import { alertDialogAciton } from "./auth";

export const getAllEventsAction = ({
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "GET",
      url:
        getState()?.auth?.userRole === USER_ROLES.CLIENT
          ? `getAllEventsClientSide`
          : `getAllEvents`,
      params,
      data: null,
      isToken: true,
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      successCallback({
        res: response,
      });
    } else {
      failureCallback({
        error,
      });
    }
  };
};

export const updateEventFromDashboardAction = ({
  payload,
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch, getState) => {
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "PUT",
      url: `update_GustoApprove_Notes`,
      // url: `getNewEventsForSuperAdmins?page=${payload?.page}`,
      params,
      data: payload,
      isToken: true,
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response) {
      successCallback({
        res: response,
      });
    } else {
      failureCallback({
        error,
      });
    }
  };
};

export const fetchNewEventAction = ({
  payload,
  params,
  successCallback,
  additionalData,
}) => {
  return async (dispatch, getState) => {
    dispatch({
      type: FETCH_NEW_EVENT_REQUEST,
      payload: additionalData,
    });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `${getNewEventUrl(payload.role, getState()?.auth?.userId)}`,
      // url: `getNewEventsForSuperAdmins?page=${payload?.page}`,
      params,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      const body = response?.data;
      const data = body?.data ?? body;
      dispatch({
        type: FETCH_NEW_EVENT_SUCCESS,
        payload: Array.isArray(data)
          ? {
              events: data,
              currentPage: body?.currentPage,
              totalPages: body?.totalPages,
              totalEvents: body?.totalEvents,
            }
          : data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_NEW_EVENT_FAILURE });
    }
  };
};

// search event requests
export const searchNewEventsAction = (payload, successCallback) => {
  return async (dispatch, getState) => {
    dispatch({ type: SEARCH_NEW_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `${getNewEventUrl(payload.role, getState()?.auth?.userId)}?eventName=${payload?.searchStr ?? ""}&page=${payload.page}`,
      // url: `getNewEventsForSuperAdmins?eventName=${payload?.searchStr ?? ""}&page=${payload.page}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: SEARCH_NEW_EVENT_SUCCESS,
        payload: response?.data,
      });

      if (successCallback) {
        successCallback();
      }
    } else if (response?.status !== 200 || error) {
      dispatch({ type: SEARCH_NEW_EVENT_FAILURE });
    }
  };
};

// assign client request
export const assignClientAction = (
  payload,
  successCallback,
  faliureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: ASSIGN_CLIENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `assignClient/${payload.eventId}`,
      data: payload.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: ASSIGN_CLIENT_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ASSIGN_CLIENT_FAILURE });
      if (faliureCallback) faliureCallback();
    }
  };
};

// update contact information
export const updateContactInformationAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_CONTACT_INFORMATION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateContactInformation/${payload?.contactId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPDATE_CONTACT_INFORMATION_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_CONTACT_INFORMATION_FAILURE });
      if (failureCallback)
        failureCallback({ message: error?.response?.data?.message });
    }
  };
};

// udpate event information
export const updateEventInfomationAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_EVENT_INFORMATION_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateEvent/${payload?.eventId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPDATE_EVENT_INFORMATION_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_EVENT_INFORMATION_FAILURE });
      if (failureCallback)
        failureCallback({ message: error?.response?.data?.message });
    }
  };
};

// delete an event
export const deleteEventAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `deleteEvent/${payload?.eventId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: DELETE_EVENT_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_EVENT_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Unable to delete event",
        },
      });
      if (failureCallback) failureCallback();
    }
  };
};

// delete a partial event
export const deletePartialEventAction = ({
  payload,
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    if (beforeCallback) {
      beforeCallback();
    }

    dispatch({ type: DELETE_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `deletePartialEvent`,
      params,
      data: payload?.data,
      isToken: true,
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response?.status === 200) {
      dispatch({ type: DELETE_EVENT_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_EVENT_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Unable to delete draft",
        },
      });
      if (failureCallback) failureCallback();
    }
  };
};

// archive event action
export const archiveEventAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ARCHIVE_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "archiveEvent",
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: ARCHIVE_EVENT_SUCCESS });
      successCallback?.(response?.data?.message);
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Success",
          message: response?.data?.message || "Event archived successfully.",
        }),
      );
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ARCHIVE_EVENT_FAILURE });
      failureCallback?.(error?.response?.data?.message);
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message || "Event archived failed.",
        }),
      );
    }
  };
};

// clear event request list
export const clearEventRequestListAction = () => {
  return async (dispatch) => {
    dispatch({ type: CLEAR_EVENT_REQUEST_LIST });
  };
};
